import { ChangeDetectorRef, Component, Input, Inject } from "@angular/core";
import * as GoldenLayout from "golden-layout";

import {
  GoldenLayoutComponentState,
  GoldenLayoutContainer,
} from "golden-layout/golden-layout.directive";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { GoldenLayoutBaseComponent } from "@app/components/editor/workspace/golden-layout-base.component";
import {
  LISTING_INFORMATION_COMPONENT_KEY,
  LISTING_TABLE_COMPONENT_KEY,
} from "@app/components/editor/workspace/golden-layout-definitions";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { Listing } from "@app/data/listing";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import * as _ from "underscore";
import { AfterViewChecked } from "@angular/core";
import { UserService } from "@app/services/user.service";

@Pipe({
  name: "renderTable",
  pure: false,
})
export class RenderTablePipe implements PipeTransform {
  oldListingsString: string;
  oldStateString: string;
  templateHtml: SafeHtml;
  previewHtml: SafeHtml;
  constructor(
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) {}

  transform(state: any, listings: Listing[], preview: boolean): any {
    var stateString = JSON.stringify(state);
    var listingsString = JSON.stringify(listings);
    if (
      !this.oldStateString ||
      stateString !== this.oldStateString ||
      listingsString !== this.oldListingsString
    ) {
      this.oldStateString = stateString;
      this.oldListingsString = listingsString;
      let html = tearSheetUtils.createTableTemplate(state);
      this.templateHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      if (listings) {
        let tearSheetOutput = tearSheetUtils
          .replaceListingTable(this.userService.locale(), html, listings)
          .replace(/\[(_[A-Z])*\]/gi, "");
        this.previewHtml =
          this.sanitizer.bypassSecurityTrustHtml(tearSheetOutput);
      }
    }
    if (preview) {
      return this.previewHtml;
    }
    return this.templateHtml;
  }
}

@Component({
  templateUrl: "./golden-layout-listing-table.component.html",
})
export class GoldenLayoutListingTableComponent
  extends GoldenLayoutBaseComponent
  implements AfterViewChecked
{
  listings: Listing[];

  constructor(
    @Inject(GoldenLayoutComponentState) state: any,
    @Inject(GoldenLayoutContainer) container: GoldenLayout.Container,
    goldenLayoutService: GoldenLayoutService,
    cdRef: ChangeDetectorRef
  ) {
    super(state, container, goldenLayoutService, cdRef);
    this.goldenLayoutService.getListings().subscribe((listings) => {
      this.listings = listings;
    });
  }
  //to prevent issues with arrays TODO: might be the thing we should do in the parent class
  ngDoCheck() {
    if (!_.isEqual(this.oldState, this.state)) {
      this.container.setState(this.state);
    }
    this.oldState = JSON.parse(JSON.stringify(this.state));
  }

  onClick() {
    this.select(LISTING_TABLE_COMPONENT_KEY);
  }
}
